import React, { HTMLAttributes } from 'react';
import { classnames } from '../../utils/classnames';
import { imageNotFound } from '../../services/helper/productFrames.config';
import { ProductCategoryKeys } from '../../common/enums/common';

interface ImageProps extends HTMLAttributes<HTMLImageElement> {
  layout: 'responsive' | 'fixed';
  alt: string;
  src: string;
  productType?: ProductCategoryKeys;
  ariaHidden?: boolean; // Optional prop to control aria-hidden attribute
}

const Image = ({ layout, alt, src, className, productType, ariaHidden, ...props }: ImageProps): JSX.Element => {
  return (
    <img
      className={classnames('xs:object-contain md:object-cover object-fill object-center max-w-full max-h-auto', className, { 'md:object-contain' : productType === ProductCategoryKeys.CONTACT_LENSES})}
      alt={alt}
      src={src}
      loading="lazy"
      decoding="async"
      onError={(event) => {
        (event.target as any).src = imageNotFound;
        (event as any).onerror = null
      }}
      {...props}
      aria-hidden={ariaHidden ?? true}
    />
    // <picture>
    //   <source srcSet={`${src}?width=1800`} media="(min-width: 1200px)" />
    //   <source srcSet={`${src}?width=1200`} media="(min-width: 1000px)" />
    //   <source srcSet={`${src}?width=1000`} media="(min-width: 800px)" />
    //   <source srcSet={`${src}?width=800`} media="(min-width: 600px)" />
    //   <img
    //     className={clsx(
    //       {
    //         "md:object-scale-down max-w-full max-h-auto":
    //           layout === "responsive",
    //         "w-auto h-auto": layout === "fixed",
    //       },
    //       className
    //     )}
    //     alt={alt}
    //     src={`${src}?height=600`}
    //     loading="lazy"
    //     decoding="async"
    //     {...props}
    //   />
    // </picture>
  );
};
export default Image;
